var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningDarker(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "w6qqgiwjra",
    d: "M0 0h40v35.349H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "q6wvtiy6qb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w6qqgiwjra"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.067 31.438c-1.605 0-2.675-1.155-2.675-2.696 0-1.57 1.1-2.695 2.675-2.695 1.574 0 2.613 1.125 2.643 2.695 0 1.54-1.04 2.696-2.643 2.696zm2.346-20.29-.653 13.418h-3.386l-.684-13.417h4.723v-.001zm16.97 19.664L22.627 1.872c-1.445-2.496-3.809-2.496-5.254 0L.617 30.811C-.828 33.307.354 35.35 3.243 35.35h33.514c2.889 0 4.071-2.042 2.626-4.537v-.001z",
    fill: "#EBAB63",
    fillRule: "nonzero",
    mask: "url(#q6wvtiy6qb)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningDarker);
export default __webpack_public_path__ + "static/media/warning_darker.dc2bed1a0ccc0ca74724b4be0daa740b.svg";
export { ForwardRef as ReactComponent };